define([
    "jquery",
    "underscore",
    "marionette",
    "clipboard-js"
], function($, _, Marionette, clipboard) {
    return Marionette.View.extend({
        el: '#content_layout',

        ui:{
            'selectAll': '#select_all',
            'copyButtons': '.btn-url',
            'accordion': '#accordion',
            'language': '#language',
            'campaign': '#campaign',
            'type': '#type',
            'size': '#size',
            'itemTpl': '#item_tpl',
            'panelTpl': '#panel_tpl'
        },

        events:{
            'change @ui.selectAll': function(e){
                var that = this;
                this.allSelected = !this.allSelected;

                this.$("input[type='checkbox'][id!='select_all']").each(function(){
                    $(this).prop('checked', that.allSelected);
                });
            },
            'click @ui.copyButtons': function(e){
                if(e) {
                    e.preventDefault();
                }

                var copyFrom = $(e.currentTarget).data('copy-from');
                var text = this.$(copyFrom).val();
                clipboard.copy(text);

                // Inform the user that he copied the link
                var helpBlock = this.$(".help-block[for='"+copyFrom+"']");
                helpBlock.removeClass('hidden');
                setTimeout(function(){
                    helpBlock.addClass('hidden');
                }, 5000);
            },
            'change @ui.language': 'renderBanners',
            'change @ui.campaign': 'renderBanners',
            'change @ui.type': 'renderBanners',
            'change @ui.size': 'renderBanners'
        },

        initialize: function(){
            this.bindUIElements();
            this.allSelected = false;

            this.renderBanners();
        },

        renderBanners: function(){
            var that = this;

            var visibleBanners = [];

            _.each(window.banners, function(item){
                if(
                    that.ui.language.val() === item.language
                    && (that.ui.campaign.val() === 'all' || that.ui.campaign.val() === item.campaign)
                    && (that.ui.size.val() === 'all' || that.ui.size.val() === item.size)
                    && (that.ui.type.val() === 'all' || that.ui.type.val() === item.type)
                ){
                    if(!_.has(visibleBanners, item.size)){
                        visibleBanners[item.size] = {};
                    }
                    if(!_.has(visibleBanners[item.size], item.type)) {
                        visibleBanners[item.size][item.type] = [];
                    }

                    (visibleBanners[item.size][item.type]).push(item);
                }
            });

            var i = 0;
            that.ui.accordion.html('');
            // Render the banners that match the current filters
            _.each(_.keys(visibleBanners), function(size){
                var types = visibleBanners[size];
                var ratio = window.sizes[size];
                var imgClass =  ratio < 1 ? 'img_wrap' : (ratio < 3 ? 'img_hwrap2' : 'img_hwrap');

                // For the very large image we need to apply the ratio CSS class
                var sizeArray = size.split("x");
                if(sizeArray && sizeArray[0] > 700){
                    imgClass = imgClass + " ratio";
                }


                // First, render the container
                that.ui.accordion.append(_.template(that.ui.panelTpl.html())({
                    'size':size,
                    'types': types,
                    'containerClass': ratio < 1 ? 'img_vwrap' : 'img_hwrap',
                    'i': i,
                }));

                // Put the banners inside
                var container = that.$('#' + size + '_container');
                _.each(_.keys(types), function(img_type) {
                    var files = types[img_type];
                    _.each(files, function(file) {
                        container.append(_.template(that.ui.itemTpl.html())({
                            'colClass': ratio < 1 ? 'col-md-3' : 'col-md-6',
                            'size': size,
                            'type': img_type,
                            'file': file,
                            'imgClass': imgClass,
                            'urls': window.urls,
                            'i': i,
                            'selectedLanguageCode': _.find(window.languages, function(item) {
                                return item.language_abbr === that.ui.language.val()
                            }).language_code
                        }));
                        i++;
                    });
                });
            });
        }
    });
});
